import { render } from "./MembersPrizesView.vue?vue&type=template&id=17334dda&scoped=true"
import script from "./MembersPrizesView.vue?vue&type=script&lang=js"
export * from "./MembersPrizesView.vue?vue&type=script&lang=js"

import "./MembersPrizesView.vue?vue&type=style&index=0&id=17334dda&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17334dda"]])

export default __exports__